import { useEffect, useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import CinematicVideo from "@/components/CinematicVideo";
import FeaturedProduct from "@/components/FeaturedProduct";
import WatchPreview from "@/components/WatchPreview";
import BrandStory from "@/components/BrandStory";
import ProductDetails from "@/components/ProductDetails";
import Craftsmanship from "@/components/Craftsmanship";
import Lifestyle from "@/components/Lifestyle";
import Scarcity from "@/components/Scarcity";
import Packaging from "@/components/Packaging";
import Footer from "@/components/Footer";
import { fetchProduct, fetchStockStatus } from "@/lib/api";

export default function Home() {
  const [product, setProduct] = useState(null);
  const [stock, setStock] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [p, s] = await Promise.all([
          fetchProduct("africa-frame"),
          fetchStockStatus("africa-frame"),
        ]);
        if (mounted) {
          setProduct(p);
          setStock(s);
        }
      } catch (err) {
        // Non-blocking — sections render with sensible fallbacks.
        // eslint-disable-next-line no-console
        console.warn("Failed to load product/stock data:", err.message);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div data-testid="home-page" className="bg-[#0a0a0a] text-white">
      <Header />
      <main>
        <Hero />
        <CinematicVideo />
        <FeaturedProduct product={product} stock={stock} />
        <WatchPreview />
        <BrandStory />
        <ProductDetails />
        <Craftsmanship />
        <Lifestyle />
        <Scarcity stock={stock} />
        <Packaging />
      </main>
      <Footer />
    </div>
  );
}
